import {
  Header,
  HeaderMenuItem,
  HeaderName,
  HeaderNavigation,
} from '@carbon/react';

export function GeneralFooter() {
  return (
    <Header
      aria-label="VozerAI Platform"
      className="[inset-block-start:auto]! [inset-block-end:0]! border-gray-200! dark:border-gray-900! border-t!"
    >
      <HeaderName href="#" prefix="VozerAI Platform">
        [Platform]
      </HeaderName>
    </Header>
  );
}
